import { useEffect } from "react";

const Privacy = () => {
  useEffect(() => {
    const scrollToHash = () => {
      const { hash } = window.location;
      if (!hash) {
        window.scrollTo(0, 0);
        return;
      }
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="container-main py-16">
        <h1 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Privacy Policy
        </h1>
        <p className="text-slate-500 mb-8">Effective date: 22 Dec 2025</p>

        <div className="space-y-8 text-slate-600 leading-relaxed">
          <section id="overview">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Overview</h2>
            <p>
              AfriGulf Market ("we", "us") respects your privacy. This policy explains how we collect,
              use, and protect personal information when you use our platform and services.
            </p>
          </section>

          <section id="information-we-collect">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Information We Collect</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Account details such as name, email, and role.</li>
              <li>Company and listing information you provide.</li>
              <li>Usage data to improve platform performance and security.</li>
              <li>Communications sent to our support channels.</li>
            </ul>
          </section>

          <section id="how-we-use-information">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">How We Use Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Provide, maintain, and improve the platform.</li>
              <li>Verify suppliers and support transactions.</li>
              <li>Respond to inquiries and provide customer support.</li>
              <li>Comply with legal and regulatory requirements.</li>
            </ul>
          </section>

          <section id="sharing">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Sharing</h2>
            <p>
              We do not sell personal data. We may share information with trusted service providers,
              regulators, or partners when required to deliver services or comply with law.
            </p>
          </section>

          <section id="data-retention">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Data Retention</h2>
            <p>
              We retain information only as long as necessary to provide services or meet legal obligations.
            </p>
          </section>

          <section id="your-rights">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Your Rights</h2>
            <p>
              You may request access, correction, or deletion of your data, subject to applicable UAE law.
            </p>
          </section>

          <section id="contact">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Contact</h2>
            <p>
              For privacy questions, contact us at afrigulfmarket@proton.me.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;


